<template>
<div>
  <article class="sign-in" v-if="!isAuthenticated">
    <div class="wrapper">
      <h1>QuaranTRIVIA</h1>
      <div id="firebaseui-auth-container"></div>
    </div>
  </article>
  <div v-if="isAuthenticated">
    <article class="table">
      <div class="wrapper">
        <h3>Score Summary</h3>
          <table>
            <thead>
              <tr>
                <th>Team Name</th>
                <th v-for="item in quiz.rounds" v-bind:key="item.roundId">Round {{item.roundId}}</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in teamSummaries" v-bind:key="item.uid">
                <td>{{item.teamName}}</td>
                <td v-for="round in item.rounds" v-bind:key="item.uid + round.round.roundId">{{round.score}} <span v-if="round.userDoubled"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M18,2 L18,18 L2,18 L2,2 L18,2 Z M20,0 L0,0 L0,20 L20,20 L20,0 Z M5.138,8.569 L6.526,8.569 L7.306,9.726 L8.077,8.569 L9.422,8.569 L7.966,10.643 L9.603,13 L8.214,13 L7.288,11.603 L6.363,13 L5,13 L6.594,10.669 L5.138,8.569 L5.138,8.569 Z M10.259,13 L10.259,12.054 C12.17,10.328 13.29,9.408 13.303,8.434 C13.303,7.889 12.985,7.457 12.213,7.457 C11.638,7.457 11.133,7.745 10.783,8.002 L10.341,6.891 C10.835,6.511 11.627,6.202 12.522,6.202 C14.044,6.202 14.867,7.086 14.867,8.289 C14.867,9.72 13.563,10.783 12.471,11.693 L12.471,11.714 L15,11.714 L15,13 L10.259,13 L10.259,13 Z" /></svg></span></td>
                <td>{{item.totalScore}}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </article>

    <article class="breadcrumbs">
      <div class="wrapper">
        <h3>Choose Round</h3>
          <ul>
              <li v-for="item in quiz.rounds" v-bind:key="item.roundId" v-bind:class="{ active: item.roundId == round }"><a href="javascript:void(0);" v-on:click="selectRound(item)">{{item.roundId}}</a></li>
          </ul>
      </div>
    </article>

    <article class="grading">
      <div class="wrapper">
        <h4>Read Questions</h4>
        
        <p v-if="round != quiz.activeRound">
          <button type="button" v-on:click="markRoundAsActive(round)">Make Round Active</button>
        </p>

        <div v-if="round == quiz.activeRound">
          <p>Round is Active</p>

          <div class="box" v-for="question in currentRound.questions" v-bind:key="question.questionId">
            <div class="wrap">
              <span class="text">{{question.question}}</span>
              <span class="actions">
                <a href="javascript:void(0)" v-on:click="markQuestionAsRead(question)" v-if="!question.hasBeenRead">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
                </a>
              </span>
            </div>
          </div>

          <div class="buttons">
            <!--<button type="button" v-on:click="toggleCountdownTimer()" v-bind:disabled="currentRound.countdownTimer && currentRound.countdownTimer.status == 'done'">
              <span v-if="!currentRound.countdownTimer || currentRound.countdownTimer.status == 'stopped'">Start</span>
              <span v-if="currentRound.countdownTimer && currentRound.countdownTimer.status == 'running'">Stop</span>
              Countdown Timer <span v-if="currentRound.countdownTimer && (currentRound.countdownTimer.time || currentRound.countdownTimer.time == 0)">({{currentRound.countdownTimer.time}})</span>
            </button>-->
            <!--<button type="button" v-if="currentRound.countdownTimer && currentRound.countdownTimer.status == 'running'" v-on:click="toggleCountdownTimer()">Stop Countdown Timer ({{currentRound.countdownTimer.time}})</button>-->
          </div>

        </div>
      </div>
    </article>

    <article class="team-names">
      <div class="wrapper">
        <h4>Teams</h4>
        <ul>
          <li v-for="userAnswer in currentRoundUserAnswers" v-bind:key="userAnswer.uid"><a href="javascript:void(0);" v-on:click="selectUserAnswers(userAnswer)">{{userAnswer.teamName}} - {{getUsersScore(userAnswer).score}} <span v-if="getUsersScore(userAnswer).userDoubled"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M18,2 L18,18 L2,18 L2,2 L18,2 Z M20,0 L0,0 L0,20 L20,20 L20,0 Z M5.138,8.569 L6.526,8.569 L7.306,9.726 L8.077,8.569 L9.422,8.569 L7.966,10.643 L9.603,13 L8.214,13 L7.288,11.603 L6.363,13 L5,13 L6.594,10.669 L5.138,8.569 L5.138,8.569 Z M10.259,13 L10.259,12.054 C12.17,10.328 13.29,9.408 13.303,8.434 C13.303,7.889 12.985,7.457 12.213,7.457 C11.638,7.457 11.133,7.745 10.783,8.002 L10.341,6.891 C10.835,6.511 11.627,6.202 12.522,6.202 C14.044,6.202 14.867,7.086 14.867,8.289 C14.867,9.72 13.563,10.783 12.471,11.693 L12.471,11.714 L15,11.714 L15,13 L10.259,13 L10.259,13 Z" /></svg></span></a></li>
        </ul>
      </div>
    </article>
    
    <article class="" v-if="selectedUserAnswers">
      <div class="wrapper">
        <h3>{{selectedUserAnswers.teamName}}</h3>
      </div>
    </article>
    
    <article class="grading" v-if="selectedUserAnswers">
      <div class="wrapper">
        <form v-on:submit.prevent="submitScore">
          <div class="box" v-for="question in currentRound.questions" v-bind:key="question.questionId">
            <p><strong>{{question.question}}</strong></p>
            <p>Correct Answer: <strong><pre>{{getCorrectAnswer(question)}}</pre></strong></p>
            <hr />
            <div class="wrap">
              <span class="text"><pre>{{getUsersAnswer(question)}}</pre></span>
              <span v-if="isUsersQuestionCorrect(question) === true" class="adjustScore"><input type="text" v-model="getUserAnswerForQuestion(question).score" /></span>
              <span class="actions">
                <a href="javascript:void(0);" v-on:click="markUsersQuestion(question, true)" class="correct" v-bind:class="{ selected: isUsersQuestionCorrect(question) === true }">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
                </a>
                <a href="javascript:void(0);" v-on:click="markUsersQuestion(question, false)" class="incorrect" v-bind:class="{ selected: isUsersQuestionCorrect(question) === false }">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>
                </a>
              </span>
            </div>
          </div>
                
          <div class="buttons">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </article>
  </div>
</div>
</template>

<script>
import firebaseservice from '../services/firebaseservice';
import Vue from 'vue';
export default {
  data: function() {
    return {
      isAuthenticated: false,
      correctAnswers: [],
      quiz: null,
      userAnswers: [],
      round: 1,
      selectedUserAnswers: null,
      countdownInterval: null
    };
  },
  computed: {
    currentRound: function() {
      for (var i=0; i<this.quiz.rounds.length; i++) {
        if (this.quiz.rounds[i].roundId == this.round) {
          return this.quiz.rounds[i];
        }
      }
      return null;
    },
    currentRoundAnswers: function () {
      var ret = [];
      var _this = this;
      this.userAnswers.forEach(function(userAnswer) {
        if (userAnswer.round == _this.round) {
          ret.push(userAnswer);
        }
      });
      return ret;
    },
    currentRoundUserAnswers: function () {
      var filteredUserAnswers = [];
      for (var i=0; i<this.userAnswers.length; i++) {
        if (this.userAnswers[i].round == this.round) {
          filteredUserAnswers.push(this.userAnswers[i]);
        }
      }
      return filteredUserAnswers;
    },
    teamSummaries: function() {
      var teamSummaries = {};
      for (var i=0; i<this.userAnswers.length; i++) {
        if (!teamSummaries[this.userAnswers[i].uid]) {
          teamSummaries[this.userAnswers[i].uid] = [];
        }
        teamSummaries[this.userAnswers[i].uid].push(this.userAnswers[i]);
      }
      var ret = [];
      var keys = Object.keys(teamSummaries);
      for (i=0; i<keys.length; i++) {
        var teamSummary = teamSummaries[keys[i]];
        var team = {
          teamName: teamSummary[0].teamName,
          uid: teamSummary[0].uid,
          totalScore: 0,
          rounds:[],
        };
        for (var j=0; j<this.quiz.rounds.length; j++) {
          var roundScore = 0;
          var userDoubled = false;
          for (var k=0; k<teamSummary.length; k++) {
            if (teamSummary[k].round != this.quiz.rounds[j].roundId) {
              continue;
            }
            for (var l=0; l<teamSummary[k].userAnswers.length; l++) {
              if (teamSummary[k].userAnswers[l].isCorrect) {
                roundScore+=parseInt(teamSummary[k].userAnswers[l].score || 1);
              }
            }
            if (teamSummary[k].userDoubled) {
              roundScore = roundScore * 2;
              userDoubled = true;
            }
          }
          team.rounds.push({
            round: this.quiz.rounds[j],
            score: roundScore,
            userDoubled: userDoubled
          });
          team.totalScore += roundScore;
        }
        ret.push(team);
      }
      // Sort by totalScore, highest first
      ret.sort((a,b) => {
        if (a.totalScore < b.totalScore) {
          return 1;
        }
        if (a.totalScore > b.totalScore) {
          return -1
        }
        return 0;
      });
      return ret;
    }
  },
  methods: {
    selectRound: function(round) {
      this.round = round.roundId;
      this.selectedUserAnswers = null;
    },
    selectUserAnswers: function(userAnswer) {
      this.selectedUserAnswers = userAnswer;
    },
    getCorrectAnswer: function(question) {
      for (var i=0; i<this.correctAnswers.length; i++) {
        if (this.correctAnswers[i].questionId == question.questionId) {
          return this.correctAnswers[i].answer;
        }
      }
    },
    getUsersAnswer: function(question) {
      var userAnswers = this.selectedUserAnswers.userAnswers;
      for (var i=0; i<userAnswers.length; i++) {
        if (userAnswers[i].questionId == question.questionId) {
          return userAnswers[i].answer;
        }
      }
    },
    getUsersScore: function(userAnswer) {
      if (!userAnswer.scoringComplete) {
        return 'Not Scored';
      }
      var score = 0;
      var userDoubled = false;
      for (var i=0; i<userAnswer.userAnswers.length; i++) {
        if (userAnswer.userAnswers[i].isCorrect) {
          score += parseInt(userAnswer.userAnswers[i].score || 1);
        }
      }
      if (userAnswer.userDoubled) {
        score = score * 2;
        userDoubled = true;
      }
      return {
        score: score,
        userDoubled: userDoubled
      }
    },
    markUsersQuestion: function(question, isCorrect) {
      var userAnswers = this.selectedUserAnswers.userAnswers;
      for (var i=0; i<userAnswers.length; i++) {
        if (userAnswers[i].questionId == question.questionId) {
          Vue.set(userAnswers[i], 'isCorrect', isCorrect);
          if (isCorrect && !userAnswers[i].score) {
            Vue.set(userAnswers[i], 'score', 1);
          }
          if (!isCorrect) {
            Vue.set(userAnswers[i], 'score', 0);
          }
        }
      }
    },
    markQuestionAsRead: function(question) {
      question.hasBeenRead = true;
      firebaseservice.upsertQuiz(this.quiz);
    },
    markRoundAsActive: function(round) {
      this.quiz.activeRound = round;
      firebaseservice.upsertQuiz(this.quiz);
    },
    toggleCountdownTimer: function() {
      var _this = this,
          counter;
      if (!_this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer) {
        _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer = {
          time: 60,
          status: 'stopped'
        };
      }
      if (_this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.status == 'done') {
        return;
      }
      else if (_this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.status == 'stopped') {
        _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.status = 'running';
        counter = _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.time;
        _this.countdownInterval = setInterval(function(){
          if(counter > 0) {
            _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.time = counter;
          } else {
            _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.time = counter;
            _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.status = 'done';
            clearTimeout(_this.countdownInterval);
          }
          if(counter % 15 == 0) {
            firebaseservice.upsertQuiz(_this.quiz);
          }
          counter--;
        }, 1000);
      } else {
        _this.quiz.rounds[_this.quiz.activeRound-1].countdownTimer.status = 'stopped';
        firebaseservice.upsertQuiz(_this.quiz);
        clearInterval(_this.countdownInterval);
      }
    },
    isUsersQuestionCorrect: function(question) {
      var userAnswers = this.selectedUserAnswers.userAnswers;
      for (var i=0; i<userAnswers.length; i++) {
        if (userAnswers[i].questionId == question.questionId) {
          return userAnswers[i].isCorrect;
        }
      }
    },
    getUserAnswerForQuestion: function(question) {
      var userAnswers = this.selectedUserAnswers.userAnswers;
      for (var i=0; i<userAnswers.length; i++) {
        if (userAnswers[i].questionId == question.questionId) {
          return userAnswers[i];
        }
      }
    },
    submitScore: async function() {
      this.selectedUserAnswers.scoringComplete = true;
      await firebaseservice.upsertUserAnswers(this.selectedUserAnswers);
      this.selectedUserAnswers = null;
    },
  },
  mounted: function() {
    var _this = this;
    firebaseservice.watchLatestQuiz((quiz) => {
      _this.quiz = quiz;
    })
    firebaseservice.watchUser((user) => {
      _this.isAuthenticated = (user != null);
    })
    firebaseservice.watchQuizAnswers(null, (answers) => {
      _this.correctAnswers = answers.correctAnswers;
    });
    firebaseservice.watchUserAnswers((userAnswers) => {
      _this.userAnswers = userAnswers;
    });
      var ui = new window.firebaseui.auth.AuthUI(window.firebase.auth());
      ui.start('#firebaseui-auth-container', {
        signInOptions: [
            window.firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
          signInSuccessWithAuthResult: function() {
            return false;
          },
        },
      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
